import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button, Toast, Spinner, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { url } from "../Components/url";
import { fetchWithAuth } from "../Components/FetchWithAuth";
import MfaSettings from "../Components/MfaSettings";
import { useAppModule } from "../Contexts/AppContext";
import { fetchMyDefaultApp, setMyDefaultApp } from "../api/navAppsApi";
import styles from "./EditUser.module.scss";
function EditUser({ data, isSelfProfile = false, activeTab = "details" }) {
    // Refresh();
    const roles = ["Counsellor", "Receptionist", "Manager", "Back Office", "Visa Counsellor", "Visa&Application Counsellor", "Lecturer", "Accountant"];
    // const { user } = useContext(UserContext);

    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userRoles, setUserRoles] = useState([]);
    const [show, setShow] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [defaultAppId, setDefaultAppId] = useState("");
    const [defaultSaving, setDefaultSaving] = useState(false);
    const { apps, setCurrentApp } = useAppModule();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [userData, setUserData] = useState({
        id: "",
        username: "",
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        status: "Active",
        role: [],
    });

    useEffect(() => {
        if (!data) {
            return;
        }
        setUserData({
            id: data.id,
            username: data.username || "",
            first_name: data.first_name || "",
            last_name: data.last_name || "",
            email: data.email || "",
            phone_number: data.phone_number || "",
            status: data.current_status || "Active",
            role: [],
        });
    }, [data]);

    const get_roles = async () => {
        if (!data?.id || isSelfProfile) {
            return;
        }
        try {
            const response = await fetchWithAuth(`${url}/get_roles/${data.id}`, {
                method: "GET",
            });
            const roleData = await response.json();
            setUserRoles(roleData);
        } catch (error) {
            // Non-admin/self-profile users don't need role management.
            setUserRoles([]);
        }
    };

    useEffect(() => {
        get_roles();
    }, [data, isSelfProfile]);

    useEffect(() => {
        if (!isSelfProfile) return;
        let alive = true;
        (async () => {
            try {
                const res = await fetchMyDefaultApp();
                if (!alive) return;
                setDefaultAppId(res?.app_id || "");
            } catch {
                if (alive) setDefaultAppId("");
            }
        })();
        return () => {
            alive = false;
        };
    }, [isSelfProfile]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setSuccessMessage("");
        setErrorMessage("");

        try {
            const endpoint = isSelfProfile ? `${url}/update_my_profile` : `${url}/edit_user`;
            const payload = isSelfProfile
                ? {
                      first_name: userData.first_name,
                      last_name: userData.last_name,
                      email: userData.email,
                      phone_number: userData.phone_number,
                  }
                : {
                      ...userData,
                      id: data.id,
                      role: userRoles,
                  };

            const response = await fetchWithAuth(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
                credentials: "include",
            });

            const responseData = await response.json();
            setSuccessMessage(responseData.message || "User updated successfully!");
            setShowToast(true);
            if (!isSelfProfile) {
                navigate("/users");
            }
        } catch (error) {
            setErrorMessage(error.message || "An error occurred. Please try again.");
            setShowToast(true);
        } finally {
            setIsLoading(false);
        }
    };
    const checkIncludes = (arr, item) => {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === item) {
                return true;
            }
        }
        return false;
    }
    const handlePasswordSubmit = async (event) => {
        if (event) {
            event.preventDefault();
        }
        setIsLoading(true);
        setSuccessMessage("");
        setErrorMessage("");

        try {
            const endpoint = isSelfProfile ? `${url}/forgot_password` : `${url}/update_password`;
            const payload = isSelfProfile
                ? { new_password: newPassword }
                : { id: userData.id, new_password: newPassword };

            const response = await fetchWithAuth(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
                credentials: "include",
            });

            const responseData = await response.json();
            setSuccessMessage(responseData.message || "Password updated successfully!");
            setShowToast(true);
            setNewPassword("");
            setShow(false);
            if (!isSelfProfile) {
                navigate("/users");
            }
        } catch (error) {
            setErrorMessage(error.message || "An error occurred. Please try again.");
            setShowToast(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRoleChange = (role, checked) => {
        setUserRoles((prevRoles) =>
            checked ? [...prevRoles, role] : prevRoles.filter((r) => r !== role)
        );
    };

    if (!data) {
        return (
            <div className={styles.root}>
                <div className={styles.emptyState}>
                    <Spinner animation="border" />
                </div>
            </div>
        );
    }

    const renderDetailsForm = () => (
        <Form onSubmit={handleSubmit}>
            <Row className={styles.formRow}>
                <Col md={6}>
                    <Form.Group controlId="first_name" className={styles.formGroup}>
                        <Form.Label className={styles.label}>Given Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter First Name"
                            value={userData.first_name}
                            onChange={(e) =>
                                setUserData({ ...userData, first_name: e.target.value })
                            }
                            className={styles.input}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group controlId="last_name" className={styles.formGroup}>
                        <Form.Label className={styles.label}>Surname</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Surname"
                            value={userData.last_name}
                            onChange={(e) =>
                                setUserData({ ...userData, last_name: e.target.value })
                            }
                            className={styles.input}
                            required
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className={styles.formRow}>
                <Col md={6}>
                    <Form.Group controlId="email" className={styles.formGroup}>
                        <Form.Label className={styles.label}>Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter Email"
                            value={userData.email}
                            onChange={(e) =>
                                setUserData({ ...userData, email: e.target.value })
                            }
                            className={styles.input}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group controlId="phone_number" className={styles.formGroup}>
                        <Form.Label className={styles.label}>Phone Number</Form.Label>
                        <Form.Control
                            type="tel"
                            placeholder="Enter Phone Number"
                            value={userData.phone_number}
                            onChange={(e) =>
                                setUserData({ ...userData, phone_number: e.target.value })
                            }
                            className={styles.input}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className={styles.formRow}>
                <Col md={6}>
                    <Form.Group controlId="username" className={styles.formGroup}>
                        <Form.Label className={styles.label}>Username</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Username"
                            value={userData.username}
                            onChange={(e) =>
                                setUserData({ ...userData, username: e.target.value })
                            }
                            readOnly={isSelfProfile}
                            className={styles.input}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col md={6} className="d-flex align-items-end">
                    <Button type="button" onClick={handleShow} variant="outline-primary" className={styles.settingsBtn}>
                        Forgot Password
                    </Button>
                </Col>
            </Row>
            {!isSelfProfile && (
                <div className={styles.optionsWrap}>
                    <div className={styles.optionsColumn}>
                        <h4 className={styles.sectionTitle}>Roles</h4>
                        {roles.map((role) => (
                            <Form.Check
                                key={role}
                                id={`role-${role}`}
                                type="checkbox"
                                label={role}
                                value={role}
                                checked={checkIncludes(userRoles, role)}
                                onChange={(e) => handleRoleChange(role, e.target.checked)}
                                className={styles.checkItem}
                            />
                        ))}
                    </div>
                    <div className={styles.optionsColumn}>
                        <h4 className={styles.sectionTitle}>Status</h4>
                        {["Active", "Inactive"].map((status) => (
                            <Form.Check
                                key={status}
                                id={`status-${status}`}
                                type="radio"
                                label={status}
                                value={status}
                                checked={userData.status === status}
                                onChange={(e) =>
                                    setUserData({ ...userData, status: e.target.value })
                                }
                                className={styles.checkItem}
                            />
                        ))}
                    </div>
                </div>
            )}
            <Row className={styles.submitRow}>
                <Col>
                    <Button type="submit" variant="primary" className={styles.submitBtn} disabled={isLoading}>
                        {isLoading ? <Spinner animation="border" size="sm" /> : "Save"}
                    </Button>
                </Col>
            </Row>
        </Form>
    );

    const renderSettingsView = () => (
        <div>
            <p className={styles.settingsIntro}>Use account settings to reset your password.</p>
            <div className={styles.settingsActions}>
                <Button type="button" onClick={handleShow} variant="primary" className={styles.settingsBtn}>
                    Forgot Password
                </Button>
            </div>
            {isSelfProfile && (
                <div className={styles.optionsWrap} style={{ marginTop: 16 }}>
                    <div className={styles.optionsColumn}>
                        <h4 className={styles.sectionTitle}>Default App</h4>
                        <Form.Select
                            value={defaultAppId}
                            onChange={(e) => setDefaultAppId(e.target.value)}
                            className={styles.input}
                        >
                            <option value="">No default (use role default)</option>
                            {(apps || [])
                                .filter((a) => !a.hidden)
                                .map((a) => (
                                    <option key={a.id} value={a.id}>
                                        {a.name}
                                    </option>
                                ))}
                        </Form.Select>
                        <div style={{ marginTop: 10 }}>
                            <Button
                                type="button"
                                variant="outline-primary"
                                disabled={defaultSaving}
                                onClick={async () => {
                                    setDefaultSaving(true);
                                    try {
                                        await setMyDefaultApp(defaultAppId || null);
                                        if (defaultAppId) setCurrentApp(defaultAppId);
                                        setSuccessMessage("Default app updated.");
                                    } catch (e) {
                                        setErrorMessage(e.message || "Failed to update default app.");
                                    } finally {
                                        setShowToast(true);
                                        setDefaultSaving(false);
                                    }
                                }}
                            >
                                {defaultSaving ? "Saving..." : "Save default app"}
                            </Button>
                        </div>
                    </div>
                </div>
            )}
            {isSelfProfile && <MfaSettings />}
        </div>
    );

    return (
        <div className={styles.root}>
            <div className={styles.wrap}>
                <Card className={styles.card}>
                    <Card.Body className={styles.cardBody}>
                        <h2 className={styles.pageTitle}>
                            {activeTab === "settings" ? "Settings" : "Edit User Details"}
                        </h2>
                        {activeTab === "settings" ? renderSettingsView() : renderDetailsForm()}
                    </Card.Body>
                </Card>
            </div>
            <Toast
                onClose={() => setShowToast(false)}
                show={showToast}
                delay={3000}
                autohide
                className={`position-fixed top-0 end-0 m-3 ${styles.toastWrap}`}
            >
                <Toast.Header>
                    <strong className="me-auto">
                        {successMessage ? "Success" : "Error"}
                    </strong>
                </Toast.Header>
                <Toast.Body>{successMessage || errorMessage}</Toast.Body>
            </Toast>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton className={styles.modalHeader}>
                    <Modal.Title className={styles.modalTitle}>Password Reset</Modal.Title>
                </Modal.Header>
                <Modal.Body className={styles.modalBody}>
                    <Form onSubmit={handlePasswordSubmit}>
                        <Row>
                            <Col>
                                <Form.Group controlId="password" className={styles.formGroup}>
                                    <Form.Label className={styles.label}>New Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Enter new password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        className={styles.input}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className={styles.modalFooter}>
                    <Button type="button" variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button type="button" variant="primary" onClick={handlePasswordSubmit} disabled={isLoading || !newPassword}>
                        {isLoading ? <Spinner animation="border" size="sm" /> : "Submit"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default EditUser;
